import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowUndoneSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m5.828 6 1.586-1.586L6 3 2 7l4 4 1.414-1.414L5.828 8H10.5a1.5 1.5 0 0 1 0 3H10v2h.5a3.5 3.5 0 1 0 0-7H5.828Z"
    />
  </svg>
);
export default IconArrowUndoneSizeS;
